import { useEffect } from "react";
import { TextField, Grid, Box, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JSubCategories,
  resetForm,
  setDialog,
} from "../../../../../app/slices/jomla/subcategorySlice";
import FilePondInput from "../../../../../helpers/FilePondInput";
import { SelectJCategory } from "../../../../../components/Selectors/jomla/SelectJCategory";
import {
  HiOutlineRectangleStack,
  HiOutlineIdentification,
  HiOutlinePhoto,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  SwitchCard,
} from "../../../../../components/FormDialog";

const JSubCategoriesForm = () => {
  const _JSubCategories = useSelector(
    (state) => state.JSubCategories.JSubCategory
  );
  const _SearchBody = useSelector((state) => state.JSubCategories.searchBody);
  const JCategory = useSelector(
    (state) => state.JCategories.JCategoriesList.data
  );
  // const _provinces = useSelector((state) => state.provinces.provinces.data);

  const isAdd = _JSubCategories.form.id ? false : true;
  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _JSubCategories.form,
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("j_category_id", data.j_category_id);
    formData.append("is_active", data.is_active ? 1 : 0);
    if (!isAdd) formData.append("_method", "PUT");
    formData.append("name", data.name);
    if (data.logo && data.logo[0].name) formData.append("logo", data.logo[0]);
    if (isAdd) {
      dispatch(JSubCategories.create(formData));
    } else {
      dispatch(JSubCategories.update(data.id, formData, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ..._JSubCategories.form });
  }, [_JSubCategories.form, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_JSubCategories.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineRectangleStack />}
      title={isAdd ? "إضافة فئة فرعية" : "تعديل الفئة الفرعية"}
      subtitle={
        isAdd
          ? "أدخل معلومات القسم الفرعي لإضافته"
          : "قم بتحديث معلومات القسم الفرعي ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="المعلومات الأساسية">
        <Grid item xs={12}>
          <Controller
            name="j_category_id"
            control={control}
            render={({ field }) => (
              <SelectJCategory
                {...field}
                required
                onChange={(e, newValue) => {
                  setValue("j_category_id", newValue ? newValue.id : null);
                }}
                value={
                  JCategory.filter((x) => x.id === field.value)[0] ?? null
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label=" الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_active"
            control={control}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label="فعال"
                onChange={(e) => {
                  setValue("is_active", e.target.checked, {
                    shouldDirty: true,
                  });
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlinePhoto />} title="الشعار">
        <Grid item xs={12}>
          <Controller
            name="logo"
            control={control}
            render={({ field }) => (
              <Box>
                {!isAdd ? (
                  <Stack direction="row" sx={{ justifyContent: "center" }}>
                    <Box
                      component="img"
                      src={field.value}
                      sx={{ width: 200 }}
                    />
                  </Stack>
                ) : null}
                <FilePondInput field={field} required={isAdd} />
              </Box>
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default JSubCategoriesForm;
